<button [attr.id]="buttonId"
        tdWbButton
        tdWbButtonSize="xs"
        (click)="onClick()">
  <ng-content></ng-content>
</button>
